import EnglishPage from "@/pages/second-opinion-thoracic-surgeon-india";
import I18nProvider from "@/components/I18nProvider";

// Arabic route for /second-opinion-thoracic-surgeon-india. Reuses the English page component untouched — Layout
// walks its JSX tree and swaps text via the translation memory, so the copy
// lives in exactly one place.
// Arabic is right-to-left; dir is set on <html> by _document and _app.
export default function ArabicPage() {
  return (
    <I18nProvider locale="ar">
      <EnglishPage />
    </I18nProvider>
  );
}
